module.exports = __webpack_public_path__ + "static/media/binBlack.b2af0aa1.svg";